import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(item: any, replace, replacement): any {
    if (item == null) {
      return '';
    }
    item = this.replaceAll(item, replace, replacement);
    return item;
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }

  escapeRegExp(string) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/replace-pipe/replace.pipe.ts